import {WebSvg} from '@/assets';
import { useVisaRequest } from '@/query/hooks';
import {Link} from 'react-router-dom';

const ApplicationExpiredError = ({code, to}: {code: string; to: string}) => {
  const request = useVisaRequest();
  return (
    <div className="w-100">
      <div className="d-flex justify-content-center align-items-center my-5 flex-column expired-part">
        <img src={WebSvg.ExpiredIcon} />
        <h1 className="mt-3">Application expired!</h1>
        {!request.bundle && <p>Please contact embassy to reinitiate your application</p>}
        <span className="mb-2">{code}</span>
        {!request.is_south_korea && 
          <div className="congratulations-bottom d-flex justify-content-center  flex-column text-center">
            <div>Want to submit another application?</div>
            <Link to={to}>Start new application</Link>
          </div>
        }
      </div>
    </div>
  );
};

export default ApplicationExpiredError;
